import {Component, Inject} from '@angular/core';
import {LearnAuthService} from '../../learn-auth.service';
import {LIB_AUTH_SERVICE_TOKEN} from '../../../../../../../micromate-learn-lib/src/lib/components/chatbot/libAuthService';
import {BrandingService} from '../../../../../../../micromate-learn-lib/src/lib/services/branding/branding.service';

@Component({
    selector: 'mm-missing-role',
    templateUrl: './missing-role.component.html',
    styleUrls: ['./missing-role.component.scss'],
    standalone: false
})
export class MissingRoleComponent {
    constructor(@Inject(LIB_AUTH_SERVICE_TOKEN) private authService: LearnAuthService,
                public brandingService: BrandingService) {
    }

    public logout(): void {
        void this.authService.startLogoutFlow();
    }
}
